import { render, staticRenderFns } from "./LayHeader.vue?vue&type=template&id=3561042e&scoped=true&"
import script from "./LayHeader.vue?vue&type=script&lang=js&"
export * from "./LayHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayHeader.vue?vue&type=style&index=0&id=3561042e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561042e",
  null
  
)

export default component.exports